export const distributePercents = (amounts: (number | null)[]): number[] => {
  // Missing amounts contribute nothing; a non-positive total has no percentages to distribute.
  const total = amounts.reduce((sum, amount) => sum + (amount ?? 0), 0)
  if (total <= 0) {
    return amounts.map(() => 0)
  }

  // Work in tenths of a percent: 100% is 1000 units. Floor each exact share first.
  const exactTenths = amounts.map(amount => ((amount ?? 0) * 1000) / total)
  const allocatedTenths = exactTenths.map(Math.floor)
  // Give leftover units to the largest fractional remainders, using input order to break ties.
  const channelsByRemainder = amounts
    .map((_, index) => index)
    .sort((a, b) => exactTenths[b] - allocatedTenths[b] - (exactTenths[a] - allocatedTenths[a]) || a - b)
  const tenthsToAllocate = 1000 - allocatedTenths.reduce((sum, tenths) => sum + tenths, 0)

  for (let i = 0; i < tenthsToAllocate; i++) {
    allocatedTenths[channelsByRemainder[i]]++
  }

  // Convert the allocated tenths back to percentages with at most one decimal.
  return allocatedTenths.map(tenths => tenths / 10)
}
